export default __webpack_public_path__ + "static/media/LP-D2-NG.38cfeeb2.jpg";